<template>
	<footer class="footer">
		<div class="wp">
			<div class="fd-top">
				<div class="fd-logo"><img alt="OCM Globe Inc - Asian food wholesale USA, 亚洲食品批发 - 美国华源食品集团"
						src="@/assets/images/fd-logo.png"></div>
				<div class="fd-share">
					<div class="fd-share-item" @click="clickShare(item)" :class="item.name"
						v-for="(item,index) in $t('footer.shareList')" :key="index">
						<img :src="item.img" :alt="item.name">
					</div>
				</div>
				<div class="address">
					<p v-for="(item,index) in $t('footer.address')" :key="index">{{item}}</p>
				</div>
			</div>
			<div class="fd-bot">
				<nav class="fd-nav">
					<dl v-for="(item,index) in $t('footer.siteMap')" :key="index">
						<dt>{{item.title}}</dt>
						<dd v-for="(sub,index) in item.nav" :key="index">
							<a :href="sub.path" target="_blank" v-if="sub.value === 1">{{sub.title}}</a>
							<router-link :to="sub.path" v-else>{{sub.title}}</router-link>
						</dd>
					</dl>
				</nav>
				<p class="copyright" v-html="$t('footer.copyright')"></p>
			</div>
		</div>

		<!--        微信，小红书弹窗-->
		<qrPop v-if="showWxPop" :pop-data="$t('wxData')" @close="showWxPop = false" />
		<qrPop v-if="showXhsPop" :pop-data="$t('xhsData')" @close="showXhsPop = false" />

	</footer>
</template>

<script>

import qrPop from "@/components/qrPop";
import cookiePop from "@/components/cookiePop";

export default {
	name: "pageFooter",
	components: {
		qrPop, cookiePop
	},
	data() {
		return {
			showWxPop: false,
			showXhsPop: false,
		};
	},
	methods: {
		clickShare(item) {
			if (item.event === 'showWx') {
				this.showWxPop = true;
			}
			if (item.event === 'showXhs') {
				this.showXhsPop = true;
			}
			if (item.event === 'link') {
				window.open(item.path, 'blank');
			}
		}
	}
}
</script>

<style scoped lang="scss">
//footer
.footer {
	color: $white2;
	background-color: $black;
	.fd-top {
		padding: 60px 0 32px;
		border-bottom: 1px solid rgba(221, 219, 203, 0.25);
		.fd-logo {
			text-align: center;
			font-size: 0;
			height: 40px;
			img {
				display: inline-block;
				height: 100%;
			}
		}
		.fd-share {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 16px 0;
			.fd-share-item {
				flex: 0 0 24px;
				border-radius: 50%;
				height: 24px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #f7f4f3;
				margin: 0 5px;
				cursor: pointer;
				img {
					display: block;
					max-width: 80%;
				}
			}
		}
		.address {
			@extend .semibold-16px;
			text-align: center;
			color: $white2;
			display: flex;
			align-items: center;
			justify-content: center;
			p {
				margin: 0 20px;
			}
		}
	}
	.fd-bot {
		padding: 32px 0 80px;
		.fd-nav {
			display: flex;
			justify-content: space-around;
			margin-bottom: 32px;
			dl {
				dt {
					@extend .semibold-16px;
					font-weight: 600;
					margin-bottom: 24px;
				}
				dd {
					a {
						@extend .regular-16px;
						color: #ffffff;
					}

					cursor: pointer;
					-webkit-transition: all 0.3s;
					-moz-transition: all 0.3s;
					-ms-transition: all 0.3s;
					-o-transition: all 0.3s;
					transition: all 0.3s;
				}
				dd a:hover {
					color: $activeColor;
				}
				dd + dd {
					margin-top: 16px;
				}
			}
		}
		.copyright {
			@extend .regular-12px;
			text-align: center;
		}
	}
}

@media only screen and (max-width: 767px) {
	.footer .fd-top .fd-logo {
		height: 32px;
	}
	.footer .fd-top .address {
		font-size: 12px;
		font-weight: normal;
	}
	.footer .fd-top .address p {
		margin: 0 5px;
	}
	.footer .fd-top {
		padding: 40px 0 16px;
	}
	.footer .fd-bot {
		padding: 0 0 60px;
	}
	.footer .fd-bot .fd-nav {
		display: block;
		margin-bottom: 16px;
	}
	.footer .fd-bot .fd-nav dl {
		padding: 16px 0;
		border-bottom: 1px solid rgba(221, 219, 203, 0.25);
	}
	.footer .fd-bot .fd-nav dl dt {
		font-size: 14px;
		margin-bottom: 16px;
	}
	.footer .fd-bot .fd-nav dl dd {
		font-size: 14px;
	}
	.footer .fd-bot .fd-nav dl dd + dd {
		margin-top: 16px;
	}
	.footer .fd-bot .copyright {
		text-align: left;
	}
}
</style>
